import { Component, Input } from '@angular/core';
import { DisplayLayoutInfo } from '../../../models/customer-display.model';

/**
 * A small, static picture of the till's sale screen in one layout: its palette, its
 * heading, two sample lines and a total. Drawn with the same colours the POS uses,
 * so support sees the screen a business's customers see without a till to hand.
 * The sample lines are illustrative, never the business's data.
 */
@Component({
  selector: 'app-customer-display-preview',
  standalone: true,
  template: `
    <div class="cdp" role="img" [attr.aria-label]="layout.label + ' layout preview'"
         [style.--navy]="layout.palette.navy" [style.--light]="layout.palette.light"
         [style.--gold]="layout.palette.gold" [style.--gold-light]="layout.palette.goldLight"
         [style.--white]="layout.palette.white" [style.--muted]="layout.palette.muted">
      <div class="cdp-head">
        <span class="cdp-name">{{ businessName || 'Your business' }}</span>
        <span class="cdp-heading">{{ layout.heading }}</span>
      </div>
      <div class="cdp-rows">
        <div class="cdp-row"><span>Sample item <span class="cdp-detail">Large</span></span><span class="cdp-price">GHS 18.00</span></div>
        <div class="cdp-row"><span>Sample item</span><span class="cdp-price">GHS 64.00</span></div>
      </div>
      <div class="cdp-total"><span>Total</span><span class="cdp-total-val">GHS 82.00</span></div>
    </div>
  `,
  styles: [`
    :host { display: block; }
    .cdp {
      border-radius: 10px; overflow: hidden; background: var(--navy); color: var(--white);
      display: flex; flex-direction: column; font-family: 'Segoe UI', system-ui, sans-serif;
      box-shadow: 0 4px 14px rgba(0, 0, 0, 0.12);
    }
    .cdp-head { background: var(--light); padding: 10px 14px; display: flex; justify-content: space-between; align-items: center; gap: 8px; }
    .cdp-name { font-size: 14px; font-weight: 700; overflow: hidden; text-overflow: ellipsis; white-space: nowrap; }
    .cdp-heading { font-size: 10px; text-transform: uppercase; letter-spacing: 1.3px; color: var(--muted); white-space: nowrap; }
    .cdp-rows { padding: 10px 14px; display: flex; flex-direction: column; gap: 6px; }
    .cdp-row { display: flex; justify-content: space-between; padding: 8px 10px; background: var(--light); border-radius: 7px; font-size: 12px; }
    .cdp-detail { color: var(--muted); font-size: 11px; margin-left: 6px; }
    .cdp-price { color: var(--gold-light); font-weight: 600; }
    .cdp-total { background: var(--light); padding: 10px 14px; display: flex; justify-content: space-between; font-size: 20px; font-weight: 700; }
    .cdp-total-val { color: var(--gold); }
  `]
})
export class CustomerDisplayPreviewComponent {
  @Input({ required: true }) layout!: DisplayLayoutInfo;
  @Input() businessName: string | null = null;
}
